const imgUrl = [
  require('../../../assets/img/solutions/financialRisk/yop.png'),
  require('../../../assets/img/solutions/financialRisk/map.png'),
  require('../../../assets/img/solutions/financialRisk/car1.png'),
  require('../../../assets/img/solutions/financialRisk/content.png'),
  require('../../../assets/img/solutions/financialRisk/car2.png'),
];

export default imgUrl;
